import SpaceCanvas from '../components/SpaceCanvas';
import SubNav from '../components/SubNav';

export default function OpenSource() {
  return (
    <>
      <SubNav label="OPEN SOURCE REGISTRY" />

      <div className="relative min-h-[calc(100vh-60px)] overflow-hidden">
        <SpaceCanvas variant="body" className="absolute inset-0 w-full h-full" />
        <div className="relative z-[1] max-w-[1000px] mx-auto px-16 py-[88px] max-[780px]:px-[22px] max-[780px]:py-[52px]">
          <div className="font-mono text-[10px] font-normal tracking-[3px] text-haze/40 mb-5">CHART Nº 003 — OPEN SOURCE REGISTRY</div>
          <h1 className="font-display text-[44px] font-bold text-ice m-0 max-[780px]:text-[clamp(30px,9vw,40px)]">The Registry</h1>
          <div className="font-mono text-[14px] font-normal leading-[1.85] text-haze/55 mt-4 max-w-[620px]">
            Public releases from the Meridian team. We are committed to working within ecosystem frameworks rather than engaging in adversarial extraction — ensuring sustainable value for all participants.
          </div>

          <div className="mt-12 p-[38px_36px] border border-solid border-haze/45 rounded-[2px] relative bg-[linear-gradient(180deg,rgba(223,230,245,0.06),rgba(223,230,245,0.01))] max-[780px]:p-[26px_20px]">
            <div className="absolute -top-1.5 left-[30px] w-[11px] h-[11px] rounded-full bg-ember shadow-[0_0_16px_rgba(255,138,76,0.9)]"></div>
            <div className="flex justify-between items-baseline gap-6 flex-wrap">
              <div className="font-display text-[22px] font-bold tracking-[1px] text-white">α — SOLANA BLACKLIST EXPLORER</div>
              <div className="flex items-center gap-2.5 font-mono text-[10px] font-normal tracking-[2px] text-haze/45">
                <span className="live-dot"></span>RELEASE 001 · LIVE · PUBLIC API
              </div>
            </div>
            <div className="font-mono text-[13px] font-normal leading-[1.85] text-haze/60 mt-4">
              Aggregates validator trust signals from Jito, Hanabi, sandwiched.me, and the Solana Foundation delegation program into one open interface — with epoch-level history, signed community reporting, and a free public API for building screening and monitoring tools.
            </div>
            <a
              href="https://solana.mrdn.one/blacklist"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-solid mt-[22px] !px-[26px] !py-[13px] inline-block"
            >
              solana.mrdn.one/blacklist ↗
            </a>
          </div>

          <div className="mt-5 p-[26px_36px] border border-dotted border-haze/25 rounded-[2px] font-mono text-[12px] font-normal tracking-[1px] text-haze/40 max-[780px]:p-[20px_20px]">
            β — FURTHER RELEASES IN PREPARATION
          </div>
        </div>
      </div>
    </>
  );
}
